module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C369_6"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("TABLES AND FIGURES")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "h3a"
  }, [_vm._v("TABLES")])]), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1. Notation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2. Order of the Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3. Key Takeaway Points of the Policy Priority Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. Proxies for the Prioritization of National Outcomes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. War and the Prioritization of National Outcomes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. Competing Explanations for Presidential Success during War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. Critical Tests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#tab4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Agencies and Programs Included in the Budgetary Data Set")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Descriptive Statistics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. Key Predictions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4. Comparing War and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5. Comparing Types of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6. Variation across Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7. Strategic Proposals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.8. Defense versus Nondefense Spending")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Expected Shifts in Roll Call Voting Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Regression Results")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_B_Altern#page_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.B1. Assessing Member Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C1. Entry into War in Afghanistan: 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C2. Entry into World War II: 77th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C3. Exit from World War II: 79th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C4. Entry into Korean War: 81st Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C5. Exit from Korean War: 83rd Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C6. Entry into Vietnam War: 88th and 89th Congresses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C7. Exit from Vietnam War: 92nd and 93rd Congresses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C8. Entry into Persian Gulf War: 101st and 102nd Congresses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C9. Exit from Persian Gulf War: 102nd Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C10. Entry into World War I: 64th and 65th Congresses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_307",
      "id": "page_xii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.C11. Exit from World War I: 65th and 66th Congresses")])]), _vm._v(" "), _c('p', {
    staticClass: "C640"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D1. Roll Call Votes by Issue Type")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("FIGURES")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1. Comparative Statics of Presidential Bargaining Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Time Series Data: Presidential Budget Requests and Congressional Appropriations for Four Agencies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Presidential Budget Requests during War and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Aggregate Shifts in Voting Behavior in the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Individual Shifts in Voting Behavior in the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3. Shifts in Congressional Voting Behavior across Policy Domains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4. Presidential Vote Share and Changes in Member Voting Behavior in the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5. Average Effects of War Initiations on Congressional Voting Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6. Average Effects of War Terminations on Congressional Voting Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#page_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.7. Shifts in Congressional Voting Behavior during Other Crisis Events")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#page_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D1. Shifts in Voting Behavior in the 107th Congress using an Alternative Estimaton Procedure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D2. Alternative Interest Group Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D3. Shifts in Voting Behavior in the 107th Congress using Six Bridge Actors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D4. Accounting for Partisan Control of Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D5. Agenda Changes in the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#page_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D6. Changes in Voting Behavior over the Course of the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D7. Changes in Voting Behavior in the California Legislature")])]), _vm._v(" "), _c('p', {
    staticClass: "P1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A.D8. Placebo Tests")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48bf5c1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List_of.vue
// module id = 72
// module chunks = 0